<template lang="pug">
  div
    p.text-sm.text-gray-500(v-html="description")
    .flex.items-center.w-full
      slot
      sw-input(
        :custom-classes="customClasses"
        v-bind="{...$props, ...$attrs}"
        v-on="$listeners"
      )
        span.pl-4.font-semibold(v-if='prefixText') {{ prefixText }}
    p.text-sm.text-red-500(v-if="error && errorMessage") {{ errorMessage }}
</template>

<script>
import SwInput from '../generic/SwInput';

export default {
  name: 'ProfilingInput',
  components: {
    SwInput,
  },
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: null,
    },
    description: {
      type: String,
      default: '',
    },
    prefixText: {
      type: String,
      default: null,
    },
  },
  computed: {
    active () {
      return this.value;
    },
    mainClasses () {
      return `rounded ${this.$slots.default ? 'rounded-l-none' : ''} md:leading-tight transition duration-200 ease-out focus:outline-none border md:border-2 font-medium md:text-lg text-gray-700 placeholder-gray-250 py-3 md:py-5`;
    },
    statusClasses () {
      if (this.error) return 'bg-red-100 hover:bg-white focus:bg-white border-red-500 hover:text-red-500 focus:text-red-500';
      if (this.active) return 'bg-green-150 hover:bg-white focus:bg-white border-green-900';
      return 'border-gray-300 bg-white hover:border-green-900 focus:border-green-900';
    },
    prefixOffsetClass () {
      return this.prefixText ? 'pl-10' : 'pl-4';
    },
    customClasses () {
      return `${this.mainClasses} ${this.statusClasses} ${this.prefixOffsetClass}`;
    },
  },
};
</script>
